import i18n, { Ti18nKeys } from "../../../../../constants/i18n";
import ET3Div from "../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import { isBlankValue } from "../../../../../core/et3-field-grid";
import { FIELD_GRID_EMPTY_VALUE } from "../../../../../core/et3-field-grid/field-grid-constants";
import Et3Text from "../../../../../core/et3-text";
import {
  SUMMARY_FACT_FONT_SIZE,
  SUMMARY_HEADER_IDENTITY_HEIGHT
} from "./summary-header-constants";

const SummaryFact = withLiteObserverAndTheme<{
  labelKey: Ti18nKeys;
  value: string;
}>((props) => {
  const { labelKey, value, theme } = props;
  const { colors } = theme;
  const isBlank = isBlankValue(value);

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      withShadow={false}
      width={0}
      height={SUMMARY_HEADER_IDENTITY_HEIGHT}
      fDirection="row"
      alignItems="center"
      justifyContent="flex-start"
      color={colors.all.transparent}
      style={{ width: "auto", height: "auto", minHeight: 0, gap: 6 }}
      onClick={() => {}}
    >
      <Et3Text
        fontFamily={"LIGHT"}
        fontSize={SUMMARY_FACT_FONT_SIZE}
        text={i18n.get(labelKey)}
        isSpan={true}
        color={colors.all.davysGrey}
        style={{ margin: 0 }}
      />
      <Et3Text
        fontFamily={"MEDIUM"}
        fontSize={SUMMARY_FACT_FONT_SIZE}
        text={isBlank ? FIELD_GRID_EMPTY_VALUE : value}
        isSpan={true}
        color={isBlank ? colors.all.gray : colors.all.maastrichtBlue}
        style={{ margin: 0 }}
      />
    </ET3Div>
  );
});
export default SummaryFact;
